// Shopify Cart Lochung Sync Script
// Zweck: Lochungsartikel still synchron halten und exakt an die Hauptartikel koppeln

(function() {
  'use strict';

  const LOCHUNG_MAPPING = {
    'Lochung nach IVZ-Norm Standardplan I': '50371640787210',
    'Lochung nach IVZ-Norm Standardplan II': '50371640819978',
    'Lochung nach IVZ-Norm Standardplan III': '50371640852746'
  };

  const LOCHUNG_VARIANT_IDS = new Set(Object.values(LOCHUNG_MAPPING));
  let syncInProgress = false;

  function normalizeLochungValue(value) {
    const rawValue = (value || '').toString().trim();

    if (!rawValue) {
      return '';
    }

    if (rawValue.toLowerCase().includes('keine lochung')) {
      return '';
    }

    if (LOCHUNG_MAPPING[rawValue]) {
      return rawValue;
    }

    return rawValue.replace(/\s+-\s+.*$/, '');
  }

  async function getCurrentCart() {
    const response = await fetch('/cart.js', {
      headers: { 'Accept': 'application/json' }
    });

    if (!response.ok) {
      throw new Error('Cart fetch failed');
    }

    return response.json();
  }

  function getRequiredLochungCounts(cart) {
    const requiredCounts = {};

    cart.items.forEach((item) => {
      const isLochungItem = LOCHUNG_VARIANT_IDS.has(String(item.variant_id));

      if (isLochungItem || !item.properties) {
        return;
      }

      for (const [key, value] of Object.entries(item.properties)) {
        if (!key || !key.toLowerCase().includes('lochung')) {
          continue;
        }

        const normalizedValue = normalizeLochungValue(value);
        const variantId = LOCHUNG_MAPPING[normalizedValue];

        if (!variantId) {
          continue;
        }

        requiredCounts[variantId] = (requiredCounts[variantId] || 0) + item.quantity;
        break;
      }
    });

    return requiredCounts;
  }

  function getActualLochungCounts(cart) {
    const actualCounts = {};

    cart.items.forEach((item) => {
      const variantId = String(item.variant_id);

      if (!LOCHUNG_VARIANT_IDS.has(variantId)) {
        return;
      }

      actualCounts[variantId] = (actualCounts[variantId] || 0) + item.quantity;
    });

    return actualCounts;
  }

  async function updateLochungItems(targetCounts, actualCounts) {
    const updates = {};

    LOCHUNG_VARIANT_IDS.forEach((variantId) => {
      const targetQuantity = targetCounts[variantId] || 0;
      const actualQuantity = actualCounts[variantId] || 0;

      if (targetQuantity !== actualQuantity) {
        updates[variantId] = targetQuantity;
      }
    });

    if (!Object.keys(updates).length) {
      return false;
    }

    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ updates })
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Lochung update failed: ${errorText}`);
    }

    return true;
  }

  async function syncLochungCart() {
    if (syncInProgress) {
      return;
    }

    syncInProgress = true;

    try {
      const cart = await getCurrentCart();
      const requiredCounts = getRequiredLochungCounts(cart);
      const actualCounts = getActualLochungCounts(cart);
      const cartChanged = await updateLochungItems(requiredCounts, actualCounts);

      if (cartChanged) {
        document.dispatchEvent(new CustomEvent('cart:updated'));

        if (typeof window.theme !== 'undefined' && window.theme.cart) {
          window.theme.cart.getCart();
        }
      }
    } catch (error) {
      console.error('❌ Fehler bei der Lochungs-Synchronisierung:', error);
    } finally {
      syncInProgress = false;
    }
  }

  function initCartValidation() {
    document.addEventListener('cart:updated', () => {
      setTimeout(syncLochungCart, 400);
    });

    document.addEventListener('change', (event) => {
      if (event.target.matches('.quantity-selector__value')) {
        setTimeout(syncLochungCart, 400);
      }
    });

    document.addEventListener('click', (event) => {
      const target = event.target.closest('a[href*="/cart/change"], [data-action="decrease-quantity"], [data-action="increase-quantity"]');

      if (target) {
        setTimeout(syncLochungCart, 700);
      }
    });

    setTimeout(syncLochungCart, 800);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartValidation);
  } else {
    initCartValidation();
  }
})();